import script from "./RequestError.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestError.vue?vue&type=script&setup=true&lang=ts"

import "./RequestError.vue?vue&type=style&index=0&id=ea8fa44c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea8fa44c"]])

export default __exports__